"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _Module = _interopRequireDefault(require("../../Icons/Module"));
var _properties = require("../../../../components/utils/properties");
var Styled = _interopRequireWildcard(require("./styles"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class MenuItemIcon extends _react.PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      error: false
    };
    this.onError = () => {
      this.setState({
        error: true
      });
    };
    this.renderIcon = () => _react.default.createElement("img", {
      src: this.props.path,
      alt: "",
      onError: this.onError
    });
  }
  render() {
    return _react.default.createElement(Styled.MenuItemIcon, (0, _properties.getNativeProps)(this.props, _properties.htmlElementProperties), !this.state.error && this.props.path ? this.renderIcon() : _react.default.createElement(_Module.default, {
      fill: this.props.theme.colors.appFrame.menu.itemIconColor
    }), this.props.displayTooltip && this.props.children);
  }
}
MenuItemIcon.defaultProps = {
  path: '',
  displayTooltip: false,
  theme: {}
};
var _default = exports.default = (0, _styledComponents.withTheme)(MenuItemIcon);